import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "donut-chart-icon",
  "use": "donut-chart-icon-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"donut-chart-icon\">\n  <path fill=\"#677078\" d=\"M13,5.08 C16.06,5.52 18.48,7.94 18.92,11 L21.95,11 C21.48,6.28 17.72,2.52 13,2.05 L13,5.08 L13,5.08 Z M18.92,13 C18.48,16.06 16.06,18.48 13,18.92 L13,21.95 C17.72,21.48 21.48,17.72 21.95,13 L18.92,13 L18.92,13 Z M11,18.92 C7.61,18.43 5,15.52 5,12 C5,8.48 7.61,5.57 11,5.08 L11,2.05 C5.95,2.55 2,6.81 2,12 C2,17.19 5.95,21.45 11,21.95 L11,18.92 Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol